export const REQUIRED_SELECTOR_ITEMS = [
  {
    value: false,
    name: 'Optional',
  },
  {
    value: true,
    name: 'Mandatory',
  },
];
